import { createFileRoute, Navigate } from '@tanstack/react-router';
import { MyTripList } from '@/components/MyTripList';
import { useCurrentCrewMember } from '@/hooks/useCurrentCrewMember';

export const Route = createFileRoute('/_auth/schedule/trips')({
  component: ScheduleTripsRoute,
});

function ScheduleTripsRoute() {
  const { data: currentUser } = useCurrentCrewMember();
  // Crew excluded from scheduling have no trips — send them home.
  if (currentUser?.includeInSchedule === false) {
    return <Navigate to="/home" />;
  }
  return <MyTripList />;
}
